module.exports = __webpack_public_path__ + "static/media/nasa3.73583fa8.jpg";